import React from 'react'
import { openPopup } from '../../../store/popupSlice'
import { useDispatch } from 'react-redux';

export default function OnDemandPlateform() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="ondemand-plateform-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3 className="heading center-heading"><span className="gradiant-color">On-Demand</span> Apps Across Platforms</h3>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="uber-eats-offer-box ondemand-plateform-box">
                <img src="/assets/home/demand-plateform-1.webp" alt="icon" className="img-respnsive" loading="lazy" />
                <label>Web</label>
                <p>Powerful web-based on-demand platform enabling seamless management, real-time insights, scalability, security, and consistent brand experiences.</p>
                <button onClick={() => dispatch(openPopup())}>view demo</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="uber-eats-offer-box ondemand-plateform-box">
                <img src="/assets/home/demand-plateform-2.webp" alt="icon" className="img-respnsive" loading="lazy" />
                <label>iOS</label>
                <p>High-performance iOS on-demand app delivering intuitive design, fast performance, secure payments, real-time tracking, and engagement.</p>
                <button onClick={() => dispatch(openPopup())}>view demo</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="uber-eats-offer-box ondemand-plateform-box">
                <img src="/assets/home/demand-plateform-3.webp" alt="icon" className="img-respnsive" loading="lazy" />
                <label>Android</label>
                <p>Scalable Android on-demand app built for reliability, smooth navigation, live updates, performance, and business growth enterprise ready.</p>
                <button onClick={() => dispatch(openPopup())}>view demo</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
